import { DataPassingContext, DataPassingProvider } from 'automation-ui-formula-editor/data-passing-panel/DataPassingContext';
import { useContext } from 'react';

/**
 *
 * This provider is only called by the FlowConfigsContainer. However, during
 * testing, we will make use of it to test data passing behavior. This component
 * prevents competing contexts while testing or if the provider is ever
 * instantiated in a second location.
 */
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const DataPassingProviderWrapper = props => {
  const {
    children
  } = props;
  const isDataPassingContextInstantiated = useContext(DataPassingContext);

  // if we already have a dataPassingContext/Provider don't make a call for another one
  if (isDataPassingContextInstantiated) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(DataPassingProvider, Object.assign({}, props, {
    children: children
  }));
};
export default DataPassingProviderWrapper;